/*
* 登录日志管理组件
*/

import CNF from '../../incs/Config.js';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';

import { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import {
    theme,
    Space,
    message,
    Table,
    Input,
} from 'antd';

const Lists = (props) => {
    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '账户', dataIndex: 'account', key: 'account', fixed: 'left', },
        { title: '远程地址', dataIndex: 'remote_ip', key: 'remote_ip', },
        { title: '主机', dataIndex: 'host', key: 'host', },
        // {title: 'user_agent', dataIndex: 'user_agent', key: 'user_agent', },
        { title: '状态码', dataIndex: 'login_res', key: 'login_res', },
        { title: '状态消息', dataIndex: 'login_msg', key: 'login_msg', },
        { title: '授权码', dataIndex: 'authorization_code', key: 'authorization_code', },
        { title: '登录时间', dataIndex: 'create_time', key: 'create_time', sorter: (a, b) => Date.parse(a.create_time) - Date.parse(b.create_time), width: CNF.tableCreateTimeColumnWidth + 60 },
    ], []);

    return (
        <Table
            columns={columns}
            size='middle'
            dataSource={props.dataLists}
            // scroll={{ x: props.x }}
            showSorterTooltip={{ target: 'sorter-icon' }}
            pagination={{
                showSizeChanger: false,
                // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                showQuickJumper: false,
                showTotal: () => `共${props.pageCount}条`,
                pageSize: CNF.pageSize,
                current: props.currentIndex,
                total: props.pageCount,
                onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                onChange: (current) => props.changeIndex(current),
            }}
        />
    );
}

// 主组件
const LogLogin = ({ btnLists }) => {
    const { token: { pageSize, messageDuration } } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);

    // 搜索条件
    const [account, setAccount] = useState('');
    const [remoteIP, setRemoteIP] = useState('');

    // 事件处理函数
    const handleIndexChange = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleAccountChange = useCallback((e) => {
        setAccount(e.target.value);
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    const handleRemoteIPChange = useCallback((e) => {
        setRemoteIP(e.target.value);
        setCurrentIndex(1); // 搜索时重置页码
    }, []);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            account: account,
            remote_ip: remoteIP,
        };

        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}logs/logins${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                message.error(data.msg, messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [pageSize, currentIndex, messageDuration, messageApi, account, remoteIP]);

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handleAccountChange}
                    placeholder='登录账户'
                    value={account}
                />
                <Input
                    onChange={handleRemoteIPChange}
                    placeholder='远程地址'
                    value={remoteIP}
                />
            </Space>
            <Lists
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={handleIndexChange}
                loading={loading}
            />

        </>
    );
}

export default LogLogin